import { Box, Divider } from '@mui/material';
import MenuBarSearch    from 'components/table/page/MenuBarSearch'
import MenuBarPaging    from 'components/table/page/MenuBarPaging'
import MenuBarReload    from 'components/table/page/MenuBarReload';
import { useToolbar } from 'contexts/ToolbarContext';

const MenuBar = ({showToolbar, disableReload, disableFilter, filter, setFilter, setCurrentFilter, pageable, status, extraMenuItems, lazySearch}) => {
  const toolbarFunctions = useToolbar()

  if (showToolbar) {
    return (
      <Box style={{flexShrink: 0}}>
        <Box style={{display: "flex", flexFlow: 'row nowrap', maxWidth: "100%", overflow: "auto", alignItems: "center" }}>
          
          <MenuBarSearch
            disableFilter={disableFilter}
            onChange={toolbarFunctions.filter}
            loading={status.busy && status.with === 'filter'}
            filter={filter}
            setFilter={setFilter}
            setCurrentFilter={setCurrentFilter}
            lazy={lazySearch}
          />
          <Box style={{flexGrow:1}} />
          <MenuBarPaging
            pageable={pageable}
            toolbarFunctions={toolbarFunctions}
            status={status}
          />
          <MenuBarReload
            disableReload={disableReload}
            onClick={toolbarFunctions.reload}
            loading={status.busy && status.with === 'reload'}
          />
          {extraMenuItems}
        </Box>
        <Divider/>
      </Box>
    )
  } else return null
}

export default MenuBar
